/**
 * Created by yonghuapro on 2017/8/22.
 */

$(function () {
    //雪花插件
    $('.p3').snowfall({
        image: "../../assets/snow.png",
        flakeCount: 60,
        maxSpeed: 5,
        maxSize: 12,
        minSize: 7,
        round: true,
        shadow: false
    });


    //注册animate方法
    $.fn.animateCss = function (animationName) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.addClass('animated ' + animationName).one(animationEnd, function () {
            $(this).removeClass('animated ' + animationName);
        });
        return this;
    };

    //修改二维码地址
    function getParams(name) {
        function UrlSearch() {
            var name, value;
            var str = location.href; //取得整个地址栏
            var num = str.indexOf("?")
            str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

            var arr = str.split("&"); //各个参数放到数组里
            for (var i = 0; i < arr.length; i++) {
                num = arr[i].indexOf("=");
                if (num > 0) {
                    name = arr[i].substring(0, num);
                    value = arr[i].substr(num + 1);
                    this[name] = value;
                }
            }
        }

        var Request = new UrlSearch(); //实例化
        return Request[name];
    }

    var from = getParams('from');
    $(".code-img").attr("src", "../../assets/qrcode-" + from + ".jpg");
    $.get("./assets/mobile/p2/box.png", function () {
        setTimeout(function () {
            $(".furniture").width($("#box").width());

            //视效插件
            var scene = $('.furniture .parallax').get(0);
            var parallax = new Parallax(scene);
        },1000)

    });


    var mySwiper = new Swiper('.swiper-container', {
        direction: 'vertical',
        loop: true,
        mousewheelControl: true,
        pagination: '.swiper-pagination',
        onSlideChangeEnd: function (swiper) {
            console.log("index", swiper.activeIndex)
            var index = swiper.activeIndex;
            var slideItems = $(".swiper-slide");
            $(".swiper-slide .bg").each(function (i) {
                if (i === index) {
                    $(this).css("z-index", -1)
                } else {
                    $(this).css("z-index", 1000)
                }
            });
            //动画初始化
            $(".animated").css({'animation-delay': 0 + 'ms'}).removeClass("animated");

            if (index === 1 || index === slideItems.length - 1) {

                // var nth = index === 1 ? 0 : 1;
                // $('.p1').eq(nth).find('.flex-item').not(".content").each(function (i) {
                //     delay = i * 200;
                //     $(this).css({'animation-delay': delay + 'ms'}).animateCss("fadeInRight");
                // });
                // $(".p1 .logo").css({'animation-delay': 300 + 'ms'}).animateCss("fadeInLeft");
                // $(".p1 .title").css({'animation-delay': 600 + 'ms'}).animateCss("fadeInLeft");
                // $(".p1 .detail").css({'animation-delay': 900 + 'ms'}).animateCss("fadeInLeft");
                // $(".p1 .player").css({'animation-delay': 1300 + 'ms'}).animateCss("flipInX");
                // $(".p1 .qrcode-wrapper").css({'animation-delay': 1500 + 'ms'}).animateCss("fadeInUp");
                // $(".p1 .partner").css({'animation-delay': 1800 + 'ms'}).animateCss("fadeInUp");

            } else if (index === 2) {
                stm_clicki('send', 'pageview', {'page': '/pc/2', 'title': 'pc2'});

                $(".p2 .title").css({'animation-delay': 0 + 'ms'}).animateCss("fadeInUp");
                $(".p2 .box").css({'animation-delay': 600 + 'ms'}).animateCss("fadeInUp");
                $(".p2 .qrcode").css({'animation-delay': 1200 + 'ms'}).animateCss("fadeInUp");
                // $(".p2 .furniture").css({'animation-delay': 1500 + 'ms'}).animateCss("zoomInUp");
                $(".p2 .furniture img").each(function (i) {
                    $(this).css({'animation-delay': 1500 + i * 100 + 'ms'}).animateCss("zoomInUp");
                })

            } else if (index === 3) {
                stm_clicki('send', 'pageview', {'page': '/pc/3', 'title': 'pc3'});

                // $(".p3 .t1").css({'animation-delay': 0 + 'ms'}).animateCss("fadeInLeft");
                // $(".p3 .t2").css({'animation-delay': 600 + 'ms'}).animateCss("fadeInLeft");
                // $(".p3 .t3").css({'animation-delay': 900 + 'ms'}).animateCss("fadeInLeft");
                // $(".p3 .t4").css({'animation-delay': 1200 + 'ms'}).animateCss("fadeInLeft");
                // $(".p3 .t5").css({'animation-delay': 1500 + 'ms'}).animateCss("fadeInLeft");
                // $(".p3 .luban").css({'animation-delay': 2500 + 'ms'}).animateCss("fadeIn");

            } else {
                stm_clicki('send', 'pageview', {'page': '/pc/4', 'title': 'pc4'});

                $(".p4 .title").css({'animation-delay': 0 + 'ms'}).animateCss("zoomInRight");

                $(".p4 .wrapper img:nth-child(1)").css({'animation-delay': 600 + 'ms'}).animateCss("fadeInLeftBig");
                $(".p4 .wrapper img:nth-child(2)").css({'animation-delay': 600 + 'ms'}).animateCss("fadeInRightBig");

            }
        }
    })
});